<template>
  <div class="onboarding-step">
    <div class="onboarding-step__wrap">
      <ProfileConnectSuccess
        @completeOnboarding="completeOnboarding"
        :error="error"
        :platform="initPlatform"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

import ProfileConnectSuccess from "@/components/Onboarding/ProfileConnectSuccess.vue";

export default {
  components: {
    ProfileConnectSuccess
  },

  computed: {
    ...mapState({
      initPlatform: state => state.initPlatform,
      game: state => state.game
    })
  },

  data() {
    return {
      error: this.$route.params.error
    };
  },

  methods: {
    completeOnboarding() {
      this.$store.dispatch("completeOnboarding");
      this.$router.push({ name: `${this.game}` });
    }
  }
};
</script>

<style lang="scss" scoped></style>
